/* eslint-disable no-nested-ternary */
import { FunctionComponent } from 'react';
import Button from '../../Input/Button/Button';
import Box from '../../Layout/Box/Box';
import styles from './List.module.scss';

export type ListProps = {
  id: string;
  options: { label: React.JSX.Element | string; value: string }[];
  skipDelete: number;
  deletePosition?: 'center' | 'top';
  positionX?: string;
  positionY?: string;
  hasAdd: boolean;
  addItemText: string;
  varient?: 'default' | 'card';
  gap?: 'sm' | 'md' | 'lg';
  onDelete: (id: string) => void;
  onAdd?: () => void;
};

type FC = FunctionComponent<ListProps>;

const List: FC = (props: ListProps) => {
  const {
    options,
    skipDelete,
    hasAdd,
    addItemText,
    positionX,
    positionY,
    onDelete,
    onAdd,
    id,
    varient = 'default',
    gap = 'sm',
    deletePosition = 'center',
  } = props;

  return (
    <div>
      <Box flx="col" gap={gap}>
        {options.map((option, index) => {
          if (index < skipDelete) {
            return (
              <div className={styles[varient]}>
                <Box>{option.label}</Box>
              </div>
            );
          }

          return (
            <div className={styles[varient]}>
              <Box gap="sm" ai={deletePosition === 'center' ? 'center' : 'fs'}>
                <div style={{ transform: `translate(${positionX || ''},${positionY || ''})` }}>
                  <Button
                    id={`delete-item-list-${id}-${index}`}
                    label=""
                    noShadow
                    color="none"
                    icon="trashcan"
                    iconLocation="left"
                    iconHeight="12px"
                    iconWidth="12px"
                    height="12px"
                    width="12px"
                    noPadding
                    onClick={() => {
                      onDelete(option.value);
                    }}
                  />
                </div>
                {option.label}
              </Box>
            </div>
          );
        })}
        {hasAdd && (
          <div style={{ marginTop: '2px' }}>
            <Button
              id={`add-item-list-${id}`}
              label={addItemText}
              icon="add"
              color="none"
              noShadow
              iconLocation="left"
              iconHeight="12px"
              iconWidth="12px"
              noPadding
              onClick={() => {
                if (onAdd) {
                  onAdd();
                }
              }}
            />
          </div>
        )}
      </Box>
    </div>
  );
};

export default List;
